import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { FormHelper } from '@helpers/form.helper';
import { InternalNote } from '@shared/internal-notes/interfaces';
import { IsfModel } from '@data-layer/models/isf';
import { EntrySummaryModel } from '@data-layer/models/entry-summaries';

@Component({
  selector: 'internal-notes',
  templateUrl: './internal-notes.component.html',
  styleUrls: ['./internal-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalNotesComponent implements OnInit {
  @Input() public internalNote: InternalNote;
  @Input() public item: IsfModel | EntrySummaryModel;
  @Input() public isShowDetails: boolean;
  @Input() public isIsf: boolean;

  @Output() public saveInternalNotes: EventEmitter<InternalNote> = new EventEmitter<InternalNote>();

  public formGroup: UntypedFormGroup;
  public infoWidth: number;
  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;

  constructor(private fb: UntypedFormBuilder, private fh: FormHelper) {}

  public ngOnInit(): void {
    this.buildForm();
    this.infoWidth = this.infoWidthCalc();
  }

  public clearForm(): void {
    this.formGroup.reset({
      internalReferenceNumber: null,
      internalNotes: null,
    });
  }

  public save(): void {
    this.saveInternalNotes.emit(this.fh.emptyStringsToNull(this.formGroup.value));
  }

  public infoWidthCalc(): number {
    const stepWidth: number = 34;
    const maxWidth: number = 100;
    let width: number = stepWidth;

    if (!!this.item.transactionNumber || !!(this.item as EntrySummaryModel).entryNumber) {
      width += stepWidth;
    }

    if (!this.isIsf && !!this.item.sentToProviderDate) {
      width += stepWidth;
    }

    if (this.isIsf && !!this.item.receivedByCbpDate) {
      width += stepWidth;
    }

    return width > maxWidth ? maxWidth : width;
  }

  private buildForm(value?: any): void {
    this.formGroup = this.fb.group({
      internalReferenceNumber: new UntypedFormControl(this.internalNote?.internalReferenceNumber, []),
      internalNotes: new UntypedFormControl(this.internalNote?.internalNotes, []),
    });
  }
}
